import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import IqamaUpdateList from "./IqamaUpdateList/IqamaUpdateList";
import IqamaRenewList from "./IqamaRenewList/IqamaRenewList";
import MuqeemDocumentPendingList from "./MuqeemDocumentPendingList/MuqeemDocumentPendingList";
import IqamaPhysicalCard from "./IqamaPhysicalCard/IqamaPhysicalCard";
import IqammaUpdate from "./IqammaSadaad/IqammaUpdate";
import nodeinstance from "../../../../nodeInstance";

export default function Iqama() {
  const [index, setIndex] = useState(0);
  const [len, setLen] = useState(0);

  const dispatch = useDispatch();
  const title = [{ label: "IQAMA", link: "/dashboard/sadaad" }];

  const token = localStorage.getItem("nodeToken");

  const response = async () => {
    try {
      const getData = await nodeinstance.get(`/iqama/getMuqeemCount`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (getData.status === 200) {
        // console.log("length to be printed here", getData);
        setLen(getData.data);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };

  useEffect(() => {
    dispatch(setBreadCrumb(title));
    response();
  }, []);

  const handleIndex = (itemNumer) => {
    setIndex(itemNumer);
  };

  const setData = () => {
    // response();
  };

  useEffect(() => {
    response();
  }, [index]);

  return (
    <>
      <div className={`ml-5 mr-5`}>
        <div className="{`flex flex-row-reverse p-10`}">
          <button
            className={`p-3  text-black uppercase text-xs mr-4 rounded-md ${index == 0 ? "bg-blue text-white" : "bg-white text-black"}`}
            onClick={() => handleIndex(0)}
          >
            1. IQAMA UPDATE LIST
          </button>
          <button
            onClick={() => handleIndex(1)}
            className={`p-3 m-2 text-black uppercase text-xs mr-4 rounded-md ${index == 1 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            4. Iqama Renew List
          </button>

          <button
            onClick={() => handleIndex(2)}
            className={`text-black uppercase text-xs mr-4 rounded-l-lg`}
          >
            <div className="flex flex-row rounded-l-lg">
              <h2
                className={`rounded-l-lg p-3 ${index == 2 ? "bg-blue text-white" : "bg-white text-black"}`}
              >
                2. MUQEEM DOCUMENT PENDING LIST
              </h2>
              <h2
                className={`rounded-r-lg bg-red text-white place-item-center p-3`}
              >
                {len}
              </h2>
            </div>
          </button>

          <button
            onClick={() => handleIndex(3)}
            className={`p-3 m-2 text-black uppercase text-xs mr-4 rounded-md ${index == 3 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            3. IQAMA PHYSICAL CARD
          </button>
          <button
            onClick={() => handleIndex(4)}
            className={`p-3 m-2 text-black uppercase text-xs mr-4 rounded-md ${index == 4 ? "bg-blue text-white" : "bg-white text-black"}`}
          >
            5. Update Iqama Expiry
          </button>
        </div>
        {index === 0 ? (
          <IqamaUpdateList setData={setData} setIndex={setIndex} />
        ) : index === 1 ? (
          <IqamaRenewList setData={setData} />
        ) : index === 2 ? (
          <MuqeemDocumentPendingList setData={setData} />
        ) : index === 3 ? (
          <IqamaPhysicalCard />
        ) : index === 4 ? (
          <IqammaUpdate />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
